module.exports = __webpack_public_path__ + "img/CRC1_TMKI67.12dbf049.png";